exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__overlay___f0JdX{position:fixed;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.75);z-index:999}.style__modal___Tr9L0{position:absolute;overflow:auto;outline:none;padding:50px 60px 60px;background:#fff;font-family:Poppins-Light;top:80px;bottom:80px;left:0;right:0;margin:0 auto;max-width:97%}.style__modal___Tr9L0.style__center___3T-bD{display:flex;justify-content:center;align-items:center;top:50%;left:50%;right:auto;bottom:auto;margin-right:-50%;transform:translate(-50%,-50%)}.style__width-1___1-1MD{max-width:92%;width:530px}.style__width-2___2Rn4m{width:720px}.style__width-3___1UG7h{width:950px}.style__width-4___2BJYV{width:1180px}.style__width-5___10_5C{width:1410px}.style__width-6___2BMnT{width:1640px}.style__width-7___1RdMi{width:1870px}.style__width-8___3CLsY{width:2100px}.style__width-9___3Gen3{width:97%}.style__widthDefault___1sI0n{width:1100px}.style__mini___2CTmv{width:400px;height:200px}@media (max-height:799px){.style__short___2cD8D{height:600px}}@media (min-height:800px){.style__short___2cD8D{height:750px}}.style__close___6Efqx{border:0;background:0;box-shadow:none;font-size:36px;position:absolute;right:20px;top:10px}.style__close___6Efqx:hover{cursor:pointer}.style__modal___Tr9L0>div{overflow:auto}", ""]);

// exports
exports.locals = {
	"overlay": "style__overlay___f0JdX",
	"modal": "style__modal___Tr9L0",
	"center": "style__center___3T-bD",
	"width-1": "style__width-1___1-1MD",
	"width-2": "style__width-2___2Rn4m",
	"width-3": "style__width-3___1UG7h",
	"width-4": "style__width-4___2BJYV",
	"width-5": "style__width-5___10_5C",
	"width-6": "style__width-6___2BMnT",
	"width-7": "style__width-7___1RdMi",
	"width-8": "style__width-8___3CLsY",
	"width-9": "style__width-9___3Gen3",
	"widthDefault": "style__widthDefault___1sI0n",
	"mini": "style__mini___2CTmv",
	"short": "style__short___2cD8D",
	"close": "style__close___6Efqx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/modal/style.css
// module id = 699
// module chunks = 0